import {
  DOPAMINE_HISTORY_SIDEBAR_WIDTH_STORAGE_KEY,
  DopamineAssistantStorageScope,
  getDopamineHistorySidebarDefaultWidth,
  getDopamineHistorySidebarWidthLimits,
} from './DopamineAssistant.utils'
import {
  DopamineResizeControls,
  useDopamineResizableWidth,
} from './useDopamineResizableWidth'

interface UseDopamineHistorySidebarWidthOptions {
  storageScope: DopamineAssistantStorageScope | null
  viewportWidth: number
}

export type DopamineHistorySidebarResize = DopamineResizeControls

/** The past chats sidebar's width in full screen, 240–480 px, per account. */
export const useDopamineHistorySidebarWidth = ({
  storageScope,
  viewportWidth,
}: UseDopamineHistorySidebarWidthOptions): DopamineHistorySidebarResize =>
  useDopamineResizableWidth({
    defaultWidth: getDopamineHistorySidebarDefaultWidth(viewportWidth),
    limits: getDopamineHistorySidebarWidthLimits(),
    storageKey: DOPAMINE_HISTORY_SIDEBAR_WIDTH_STORAGE_KEY,
    storageScope,
  })
